import React, { useState, useEffect } from 'react';
import { Drawer, Spin, Space, message, Row, Col, Progress, Tooltip } from 'antd';
import moment from "moment-timezone";
import { InfoCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import GlobalChart from './CRMCharts';
import { SalesTargetWrap } from '../style';
import { processGraphData2, ExchangeCurrency, processTwoBar } from '../Filters/FilterConditions'
import { PieIcon, VBIcon, DonutIcon, HBIcon, LineIcon, CancelIcon, SHBIcon, SVBIcon } from '../../../components/Icons/Icons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import {
    FetchgetAllOepenDealByAccountId,
    FetchgetAllClosedDealByAccountId,
    FetchleadConversionByAccount,
    FetchcontactByAccountAndId,
    FetchaccountActivityReportByAccountId,
    FetchresourceUtilizationReportByAccountId,
    FetchAllEntityScoreForLastSixmonth,
} from '../../../Api/Services/Account360ApiService'
import { FetchCurrentYearForcast } from '../../../Api/Services/ForcastApiService'

// const colorMapping = {
//     'Discovery': '#A86464',
//     'Qualification': '#FFD966',
//     'Prospecting': '#87CEEB',
//     'Proposal': '#FF7878',
//     'Negotiation': '#5F63F2',
//     'Won': '#20C997',
//     'on-Hold': '#BBBBBB',
//     'On-Hold': '#BBBBBB',
//     'Lost': '#30475E'
// };
const stageOrder = [
    'Prospecting',
    'Qualification',
    'Discovery',
    'Proposal',
    'Negotiation',
    'Won',
    'on-Hold',
    'On-Hold',
    'Lost'
];

const Popup = ({ currency, setCurrency, DataId, UserId }) => {
    const pageSize = 10;
    const OwnpageSize = 20;
    const localData = useSelector((state) => state.localRedux);
    const defaultCurrency = localData.currency
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const [currentData, setCurrentData] = useState()
    const [paginationState, setPaginationState] = useState({});
    const [pageLoading, setPageLoading] = useState()
    const [chartData, setChartData] = useState();
    const [data, setData] = useState()
    const [data1, setData1] = useState()
    const [apiData3, setApiData3] = useState([])
    const [apiData4, setApiData4] = useState([])
    const [apiData6, setApiData6] = useState([])
    const [accountReport3, setAccountReport3] = useState()
    const [accountReport4, setAccountReport4] = useState()
    const [accountReport5, setAccountReport5] = useState()
    const [accountReport6, setAccountReport6] = useState()
    const [total2, setTotal2] = useState()
    const [chartData2, setChartData2] = useState({ dataIn: [], labels: [] });
    const [isQualified, setIsQualified] = useState("YES")
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const DateFilterCondition = (date) => {
        const tzString = profile?.timeZone || "(GMT+0:00) UTC";
        const tz = extractTimeZoneName(tzString);
        const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
        const getMonthIndex = (monthName) => {
            const months = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            return months.findIndex(
                m => m.toLowerCase() === monthName.toLowerCase()
            );
        };
        const fiscalStartMonthIndex = getMonthIndex(companyProfile.monthName);
        const dateConvert = moment(date, ['DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'], true).format('YYYY-MM-DD');
        const fieldValue = new Date(dateConvert);

        // Financial Year Calculations
        const today = new Date(currentrealTime);
        const thisMonth = today.getMonth();
        const thisYear = today.getFullYear();

        // Fiscal Year ends in the month before the next fiscal start month
        // So if today is May 2025 and FY ends in August, we're in FY 2025
        const fiscalYear =
            thisMonth >= fiscalStartMonthIndex ? thisYear + 1 : thisYear;
        // Fiscal Year Ranges
        const startOfFinancialYear = new Date(fiscalYear - 1, fiscalStartMonthIndex, 1);
        const endOfFinancialYear = new Date(fiscalYear, fiscalStartMonthIndex, 0);
        endOfFinancialYear.setHours(23, 59, 59, 999);

        return fieldValue >= startOfFinancialYear && fieldValue <= endOfFinancialYear;
    };
    // const chartOptions = {
    //     legend: {
    //         display: false,
    //         labels: {
    //             display: false,
    //         },
    //     },
    //     plugins: {
    //         datalabels: {
    //             display: false,
    //         },
    //     },
    //     scales: {
    //         yAxes: [
    //             {
    //                 stacked: true,
    //                 gridLines: {
    //                     display: false,
    //                 },
    //                 ticks: {
    //                     display: false,
    //                     callback: (value) => (value.length > 15 ? `${value.slice(0, 15)}…` : value)

    //                 },
    //             },
    //         ],
    //         xAxes: [
    //             {
    //                 stacked: true,

    //                 gridLines: {
    //                     display: false,
    //                 },
    //                 ticks: {
    //                     display: false,
    //                     callback: (value) => (value.length > 15 ? `${value.slice(0, 15)}…` : value)

    //                 },
    //             },
    //         ],
    //     },
    // };
    function extractAllAccounts(root) {
        const result = [];
        const stack = [root];
        while (stack.length > 0) {
            const node = stack.pop();
            if (Array.isArray(node.accountsAndDeals)) {
                result.push(...node.accountsAndDeals);
            }
            if (Array.isArray(node.reporties) && node.reporties.length > 0) {
                stack.push(...node.reporties);
            }
            if (Array.isArray(node.reportingCompanyRoles) && node.reportingCompanyRoles.length > 0) {
                stack.push(...node.reportingCompanyRoles);
            }
        }
        return result;
    }
    function extractAllDeals(root) {
        const allAccounts = extractAllAccounts(root);
        return allAccounts.flatMap(acc => {
            return Array.isArray(acc.deals) ? acc.deals : [];
        });
    }
    // const datasetKeyProvider = () => {
    //     return Math.random().toString();
    // };
    const getRandomDarkerColor = (() => {
        const hueCache = {}; // Keeps hues per identifier (e.g., per graph)

        function hslToHex(h, s, l) {
            s /= 100;
            l /= 100;

            const k = n => (n + h / 30) % 12;
            const a = s * Math.min(l, 1 - l);
            const f = n =>
                Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));

            return `#${[f(0), f(8), f(4)]
                .map(x => x.toString(16).padStart(2, '0'))
                .join('')}`;
        }

        function isHueTooClose(h, existingHues) {
            return existingHues.some(existing => Math.abs(h - existing) < 25);
        }

        return function getRandomDarkerColor(identifier = 'default') {
            if (!hueCache[identifier]) {
                hueCache[identifier] = [];
            }

            const usedHues = hueCache[identifier];
            let hue;
            let attempts = 0;

            do {
                hue = Math.floor(Math.random() * 360);
                attempts += 1;
            } while (isHueTooClose(hue, usedHues) && attempts < 100);

            usedHues.push(hue);

            const saturation = 65 + Math.random() * 15; // rich and vibrant
            const lightness = 45 + Math.random() * 10;  // ideal for graph contrast

            return hslToHex(hue, saturation, lightness);
        };
    })();
    const setGroupData = async (item, mergedData) => {
        if (!('graphDatas' in item)) {
            item.graphDatas = {
                labels: [],
                datasets: [],
                Sumtotal: 0,
                LegendType: "",
                dateFilter: {
                    isFilter: "No",
                    allData: { labels: [], datasets: [], Sumtotal: 0 },
                    weekData: { labels: [], datasets: [], Sumtotal: 0 },
                    yearData: { labels: [], datasets: [], Sumtotal: 0 },
                    monthData: { labels: [], datasets: [], Sumtotal: 0 },
                    filterType: "this_year",
                },
            };
        }
        const Row = item.graphRow;
        const Type = item.graphType;
        const Column = item.graphColumn;
        const GroupBy = item.graphGroupBy;
        const DateFilter = item.graphFilterColoum;
        const Source = item.graphSource
        const SortData = item.graphSort
        if (DateFilter) {
            const filteredData = await processGraphData2(mergedData, Row, Column, Type, item.graphDatas.dateFilter, GroupBy, Source, DateFilter, SortData, companyProfile, profile);
            item.graphDatas.dateFilter.weekData = filteredData?.weekData;
            item.graphDatas.dateFilter.monthData = filteredData?.monthData;
            item.graphDatas.dateFilter.yearData = filteredData?.yearData;
            item.graphDatas.datasets = filteredData?.yearData.datasets ?? [];
            item.graphDatas.labels = filteredData?.yearData.labels ?? [];
            item.graphDatas.Sumtotal = filteredData?.yearData.Sumtotal ?? 0;
        }
        item.graphDatas.LegendType = "TotalCount";
        item.graphDatas.dateFilter.allData.LegendType = "TotalCount";
        if (Row !== null && Column !== null) {
            const labelsSet = new Set(mergedData.map((dataItem) => dataItem[Row]));
            const labels = Array.from(labelsSet);
            if (Type !== "Stacked Vertical Bar" && Type !== "Stacked Horizontal Bar") {
                const datasets = [];
                const datas = [];
                let backgroundColors = [];
                labels.forEach((label) => {
                    const filteredData = mergedData.filter((dataItem) => dataItem[Row] === label);
                    let sum = 0;
                    filteredData.forEach((dataItem) => { const value = dataItem[Column]; sum += Source === "Sum" ? value : 1; });
                    datas.push(sum);
                });

                if (Type === "Donut" || Type === "Pie Chart") {
                    labels.forEach(() => { backgroundColors.push(getRandomDarkerColor(`Graph-${item.graphId}`)); });
                } else {
                    backgroundColors = getRandomDarkerColor(`Graph-${item.graphId}`);
                }
                if (SortData) {
                    const combined = labels.map((label, i) => ({
                        label: (label === null || label === "" || label === undefined) ? "Undefined" : label,
                        value: datas[i],
                        bg: Array.isArray(backgroundColors) ? backgroundColors[i] : backgroundColors
                    }));
                    combined.sort((a, b) => b.value - a.value);
                    const defined = combined.filter(d => d.label !== "Undefined");
                    const undefinedOnes = combined.filter(d => d.label === "Undefined");
                    const finalSorted = [...defined, ...undefinedOnes];
                    labels.splice(0, labels.length, ...finalSorted.map(d => d.label));
                    datas.splice(0, datas.length, ...finalSorted.map(d => d.value));
                    if (Array.isArray(backgroundColors)) {
                        backgroundColors = finalSorted.map(d => d.bg);
                    }
                }
                datasets.push({
                    data: datas,
                    backgroundColor: backgroundColors,
                });
                const updatedData = labels.map((item) => item === null || item === "" || item === undefined ? "Undefined" : item);
                if (!DateFilter) {
                    item.graphDatas.labels = updatedData;
                    item.graphDatas.datasets = datasets;
                    item.graphDatas.Sumtotal = datas.reduce((accumulator, currentValue) => accumulator + Number(currentValue || 0), 0);
                }
                item.graphDatas.dateFilter.allData.labels = updatedData;
                item.graphDatas.dateFilter.allData.datasets = datasets;
                item.graphDatas.dateFilter.allData.Sumtotal = datas.reduce((accumulator, currentValue) => accumulator + Number(currentValue || 0), 0);
                if (Type === "Line Graph") {
                    item.graphDatas.datasets[0].borderWidth = 1;
                    item.graphDatas.datasets[0].fill = false;
                }
                if (Type === "Vertical Bar" || Type === "Horizontal Bar") {
                    item.graphDatas.datasets[0].barPercentage = 0.6;
                }
            }
            if ((Type === "Stacked Vertical Bar" || Type === "Stacked Horizontal Bar") && GroupBy !== null) {
                const datasets = [];
                const groupBySet = new Set(mergedData.map((dataItem) => dataItem[GroupBy]));
                const groupByValues = Array.from(groupBySet);
                groupByValues.forEach((value) => {
                    const filteredData = mergedData.filter((dataItem) => dataItem[GroupBy] === value);
                    const datas = labels.map((label) => {
                        const filteredLabelData = filteredData.filter((dataItem) => dataItem[Row] === label);
                        return filteredLabelData.reduce((sum, dataItem) => sum + (Source === "Sum" ? dataItem[Column] : 1), 0);
                    });
                    datasets.push({
                        data: datas,
                        backgroundColor: getRandomDarkerColor(`Graph-${item.graphId}`),
                        barPercentage: 0.6,
                        groupLables: value === null || value === "" || value === undefined ? "Undefined" : value,
                    });
                });
                if (SortData) {
                    const totals = labels.map((_, i) =>
                        datasets.reduce((sum, ds) => sum + Number(ds.data[i] || 0), 0)
                    );

                    const combined = labels.map((label, i) => ({
                        label: (label === null || label === "" || label === undefined) ? "Undefined" : label,
                        values: datasets.map(ds => ds.data[i]),
                        total: totals[i]
                    }));
                    combined.sort((a, b) => b.total - a.total);
                    const defined = combined.filter(d => d.label !== "Undefined");
                    const undefinedOnes = combined.filter(d => d.label === "Undefined");
                    const finalSorted = [...defined, ...undefinedOnes];
                    // Rebuild arrays
                    const sortedLabels = finalSorted.map(d => d.label);
                    const sortedDatasets = datasets.map((ds, dsIdx) => ({
                        ...ds,
                        data: finalSorted.map(d => d.values[dsIdx])
                    }));
                    item.graphDatas.dateFilter.allData.labels = sortedLabels;
                    item.graphDatas.dateFilter.allData.datasets = sortedDatasets;
                    if (!DateFilter) {
                        item.graphDatas.labels = sortedLabels;
                        item.graphDatas.datasets = sortedDatasets;
                    }
                } else {
                    const updatedData = labels.map((item) => item === null || item === "" || item === undefined ? "Undefined" : item);
                    item.graphDatas.dateFilter.allData.labels = updatedData;
                    item.graphDatas.dateFilter.allData.datasets = datasets;
                    if (!DateFilter) {
                        item.graphDatas.labels = updatedData;
                        item.graphDatas.datasets = datasets;
                    }
                }
                if (!DateFilter) { item.graphDatas.Sumtotal = datasets.reduce((accumulator, currentObj) => { const sumOfData = currentObj.data.reduce((sum, value) => sum + Number(value || 0), 0); return accumulator + sumOfData; }, 0); }
                item.graphDatas.dateFilter.allData.Sumtotal = datasets.reduce((accumulator, currentObj) => { const sumOfData = currentObj.data.reduce((sum, value) => sum + Number(value || 0), 0); return accumulator + sumOfData; }, 0);
            }
        }
        if (item.graphId === 3) { setAccountReport3(item) }
        if (item.graphId === 4) { setAccountReport4(item) }
        if (item.graphId === 6) { setAccountReport6(item) }
    };
    const processData = async (item, mergedData) => {
        if (!('graphDatas' in item)) {
            item.graphDatas = {
                labels: [],
                totalAdd: 0,
                totalConvert: 0,
                Add: [],
                Convert: [],
                dateFilter: {
                    allData: { labels: [], totalAdd: 0, totalConvert: 0, Add: [], Convert: [] },
                    weekData: { labels: [], totalAdd: 0, totalConvert: 0, Add: [], Convert: [] },
                    yearData: { labels: [], totalAdd: 0, totalConvert: 0, Add: [], Convert: [] },
                    monthData: { labels: [], totalAdd: 0, totalConvert: 0, Add: [], Convert: [] },
                    filterType: "this_year",
                },
            };
        }
        const { graphRow: Row, graphColumn: Column, graphFilterColoum: DateFilter } = item;
        if (Row !== null && Column !== null) {
            const groupData = (data) => {
                const result = Object.values(
                    data.reduce((acc, item) => {
                        const groupValue = item[Row];
                        const isConverted = item[Column];
                        if (!acc[groupValue]) {
                            acc[groupValue] = {
                                [Row]: groupValue,
                                addCount: 0,
                                convertedCount: 0,
                            };
                        }
                        acc[groupValue].addCount += 1;
                        if (isConverted === 1) acc[groupValue].convertedCount += 1;
                        return acc;
                    }, {})
                );
                return {
                    labels: result.map((item) => (item[Row] === null || item[Row] === '' || item[Row] === undefined ? 'Undefined' : item[Row])),
                    totalAdd: result.reduce((accumulator, item) => accumulator + item.addCount, 0),
                    totalConvert: result.reduce((accumulator, item) => accumulator + item.convertedCount, 0),
                    Add: result.map((item) => item.addCount),
                    Convert: result.map((item) => item.convertedCount),
                };
            };
            if (DateFilter) {
                const filteredData = await processTwoBar(mergedData, Row, Column, item.graphDatas.dateFilter, DateFilter, companyProfile, profile);
                item.graphDatas.dateFilter.weekData = filteredData?.weekData;
                item.graphDatas.dateFilter.yearData = filteredData?.yearData;
                item.graphDatas.dateFilter.monthData = filteredData?.monthData;
                item.graphDatas = {
                    ...item.graphDatas,
                    ...filteredData?.yearData
                };
                item.graphDatas.dateFilter.allData = groupData(mergedData);

            }
            else {
                const grouped = groupData(mergedData);
                item.graphDatas = {
                    ...item.graphDatas,
                    ...grouped,
                };
                item.graphDatas.dateFilter.allData = grouped;
            }
        }
        if (item.graphId === 5) { setAccountReport5(item) }
    }
    function transformAccountData(account) {
        const interactionTypes = ["email", "callLogs", "meeting", "task"];

        const result = interactionTypes.flatMap(type => {
            // Get the array for this type, default to empty if not present
            const items = account[type] || [];

            return items.map(item => ({
                interactionType: type === "email" ? "Emails" :
                    type === "callLogs" ? "Call Logs" :
                        type === "meeting" ? "Meetings" :
                            type === "task" ? "Tasks" : "",
                interactionName: type === "email" ? item.subject :
                    type === "callLogs" ? item.call_title :
                        type === "meeting" ? item.subject :
                            type === "task" ? item.task_name : "",
                accountName: account.entityType
            }));
        });

        return result;
    }
    function transformAccountData1(account) {
        const interactionTypes = ["product", "service", "staffRole"];
        const result = interactionTypes.flatMap(type => {
            const items = account[type] || [];
            return items.map(item => ({
                interactionType: type === "product" ? "Product" :
                    type === "service" ? "Service Line" :
                        type === "staffRole" ? "Staff Role" : "",
                interactionName: type === "product" ? item.product_name :
                    type === "service" ? item.service_name :
                        type === "staffRole" ? item.roleName : "",
                accountName: account.accountName
            }));
        });
        return result;
    }
    function replaceEmptyValues(data) {
        return data.map(obj =>
            Object.fromEntries(
                Object.entries(obj).map(([key, value]) => [
                    key,
                    value === null || value === undefined || value === "" ? "Undefined" : value
                ])
            )
        );
    }
    async function getSalesTargetWithGoalsByAccountId() {
        try {
            const allAccounts = extractAllAccounts(currentData)
            const matchedAccount = allAccounts.find(
                acc => acc.accountId === Number(DataId)
            );
            const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
            const ConvertRate = defaultCurrency?.exchangeRate;
            let DealValue = 0;
            let targetValue = 0;
            if (matchedAccount) {
                DealValue = await ExchangeCurrency(Number(matchedAccount?.AccountYTDandROY?.actualValues || 0), ConvertRate);
                targetValue = await ExchangeCurrency(Number(matchedAccount?.AccountYTDandROY?.forecastTarget || 0), ConvertRate);
            }
            setChartData({
                dealValue: Number(DealValue?.toFixed(CurencyDecimalPlace)),
                target: Number(targetValue?.toFixed(CurencyDecimalPlace)),
            })
        } catch (error) {
            setChartData({
                dealValue: 0,
                target: 0,
            })
            message.error(error);
        }
    }
    async function getAllClosedDealByAccountId() {
        try {
            const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
            const ConvertRate = defaultCurrency?.exchangeRate;
            const allDeals = extractAllDeals(currentData)
            const data = await FetchgetAllClosedDealByAccountId(UserId, DataId)
            const dataWithCurrency = await Promise.all(
                data.map(async item => {
                    const matchedDeal = allDeals.find(
                        acc => acc.dealsId === Number(item.dealId)
                    );
                    const isCurrentFY = DateFilterCondition(item?.actualCloserDate);
                    const dealValueToUse = isCurrentFY ? Number(item.dealValue || 0) : 0;
                    // const profitToUse = isCurrentFY ? Number(item.dealProfit || 0) : 0;
                    const actualProfit = Number(matchedDeal?.dealYTDANDROY?.actualValues || 0);
                    const margin = Number(matchedDeal?.actualDealMargin || 0);
                    let revenue = 0;
                    if (margin > 0) {
                        revenue = actualProfit * (margin / 100);
                    }
                    const CurrecnyDealValue = await ExchangeCurrency(Number(dealValueToUse), ConvertRate)
                    const currencyForecast = await ExchangeCurrency(Number(revenue), ConvertRate)
                    const currencyProfit = await ExchangeCurrency(Number(actualProfit || 0), ConvertRate)
                    return {
                        ...item,
                        dealValue: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)),
                        dealRevenue: Number(currencyProfit?.toFixed(CurencyDecimalPlace)),
                        forecastedValue: Number(currencyForecast?.toFixed(CurencyDecimalPlace))
                    };
                })
            );
            const sortedData = dataWithCurrency.sort((a, b) => b.dealValue - a.dealValue);
            const dealValue = sortedData.filter(item => item.dealValue !== undefined && item.dealValue !== null && item.dealValue !== "").map(item => item.dealValue);
            const dealRevenue = sortedData.filter(item => item.dealRevenue !== undefined && item.dealRevenue !== null && item.dealRevenue !== "").map(item => item.dealRevenue);
            const dealForecast = sortedData.filter(item => item.forecastedValue !== undefined && item.forecastedValue !== null && item.forecastedValue !== "").map(item => item.forecastedValue);
            const totalDValue = dealValue.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            const totalPValue = dealRevenue.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            const totalFValue = dealForecast.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            const labels = sortedData.map(item => item.dealName);
            const OrderByPipeline = sortedData.sort((a, b) => {
                return stageOrder.indexOf(a.pipelineStage) - stageOrder.indexOf(b.pipelineStage);
            });
            const structure = {
                graphId: 2,
                dealValue,
                dealRevenue,
                dealForecast,
                labels,
                totalDValue,
                totalPValue,
                totalFValue,
                AllDeal: OrderByPipeline
            }
            setData1(structure);
        } catch (error) {
            message.error(error);
        }
    }
    async function leadConversionByAccount() {
        try {
            const data = await FetchleadConversionByAccount(DataId)
            const cleanedData = replaceEmptyValues(data)
            processData({
                graphId: 5,
                graphName: "Leads Added vs Converted (by Lead Source)",
                graphType: "Bar+Line",
                graphRow: "lead_source_name",
                graphColumn: "is_converted",
                graphGroupBy: null,
                graphSource: "Sum",
                graphFilterColoum: null,
            }, cleanedData)
        } catch (error) {
            message.error(error);
        }
    }
    async function contactByAccountAndId() {
        try {
            const data = await FetchcontactByAccountAndId(DataId)
            const transformedData = data.flatMap(account =>
                account.contacts.map(contact => ({
                    accountName: account.accountName,
                    contactSource: contact.contactSourceName,
                    firstName: contact.first_name,
                    influencedWonDeals: contact.influencedWonDeals === "No" ? "Unconverted Contacts" : "Converted Contacts"
                }))
            );
            const cleanedData = replaceEmptyValues(transformedData)
            setApiData6(cleanedData)
            setGroupData({
                graphId: 6,
                graphName: "Contacts by Source (Converted vs Unconverted)",
                graphType: "Stacked Vertical Bar",
                graphRow: "contactSource",
                graphColumn: "firstName",
                graphGroupBy: "influencedWonDeals",
                graphSource: "Count",
                graphFilterColoum: null,
                graphSort: true,
            }, cleanedData)
        } catch (error) {
            message.error(error);
        }
    }
    async function accountActivityReportByAccountId() {
        try {
            const data = await FetchaccountActivityReportByAccountId(UserId, DataId)
            const transformedData = transformAccountData(data);
            const cleanedData = replaceEmptyValues(transformedData)
            setApiData3(cleanedData)
            setGroupData({
                graphId: 3,
                graphName: "Activity Report (by Activity Type)",
                graphType: "Pie Chart",
                graphRow: "interactionType",
                graphColumn: "interactionName",
                graphGroupBy: null,
                graphSource: "Count",
                graphFilterColoum: null,
                graphSort: true
            }, cleanedData)
        } catch (error) {
            message.error(error);
        }
    }
    async function resourceUtilizationReportByAccountId() {
        try {
            const data = await FetchresourceUtilizationReportByAccountId(UserId, DataId)
            const transformedData = transformAccountData1(data);
            const cleanedData = replaceEmptyValues(transformedData)
            setApiData4(cleanedData)
            setGroupData({
                graphId: 4,
                graphName: "Resource Utilization (by Resource)",
                graphType: "Pie Chart",
                graphRow: "interactionType",
                graphColumn: "interactionName",
                graphGroupBy: null,
                graphSource: "Count",
                graphFilterColoum: null,
                graphSort: true
            }, cleanedData)
        } catch (error) {
            message.error(error);
        }
    }
    async function AllEntityScoreForLastSixmonth() {
        try {
            const data = await FetchAllEntityScoreForLastSixmonth("Account", DataId)
            const SortedData = data.sort((a, b) => a.entityScoringId - b.entityScoringId);
            const dataIn = SortedData?.map(item => {
                const val = Number(item?.numericScore);
                return val === null || Number.isNaN(val) ? "0.00" : val.toFixed(2);
            });
            const labels = SortedData?.map(item => item.month);
            setChartData2({ dataIn, labels });
            const Currentunique = [...new Set(SortedData?.map(yearData => yearData.numericScore))];
            setTotal2(Currentunique[0]?.toFixed(2));
        } catch (error) {
            message.error(error);
        }
    }
    async function getAllOepenDealByAccountId(Type) {
        try {
            const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
            const ConvertRate = defaultCurrency?.exchangeRate;
            const data = await FetchgetAllOepenDealByAccountId(UserId, DataId, Type)
            const dataWithCurrency = await Promise.all(
                data.map(async item => {
                    const CurrecnyDealValue = await ExchangeCurrency(Number(item.dealValue), ConvertRate)
                    const currencyForecast = await ExchangeCurrency(Number(item.forecastedValue), ConvertRate)
                    const currencyProfit = await ExchangeCurrency(Number(item.dealProfit), ConvertRate)
                    return {
                        ...item,
                        dealValue: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)),
                        dealProfit: Number(currencyProfit?.toFixed(CurencyDecimalPlace)),
                        forecastedValue: Number(currencyForecast?.toFixed(CurencyDecimalPlace))
                    };
                })
            );
            const sortedData = dataWithCurrency.sort((a, b) => b.dealValue - a.dealValue);
            const dealValue = sortedData.filter(item => item.dealValue !== undefined && item.dealValue !== null && item.dealValue !== "").map(item => item.dealValue);
            const dealProfit = sortedData.filter(item => item.dealProfit !== undefined && item.dealProfit !== null && item.dealProfit !== "").map(item => item.dealProfit);
            const dealForecast = sortedData.filter(item => item.forecastedValue !== undefined && item.forecastedValue !== null && item.forecastedValue !== "").map(item => item.forecastedValue);
            const totalDValue = dealValue.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            const totalPValue = dealProfit.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            const totalFValue = dealForecast.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            const labels = sortedData.map(item => item.dealName);
            const OrderByPipeline = sortedData.sort((a, b) => {
                return stageOrder.indexOf(a.pipelineStage) - stageOrder.indexOf(b.pipelineStage);
            });
            const structure = {
                graphId: 1,
                dealValue,
                dealProfit,
                dealForecast,
                labels,
                totalDValue,
                totalPValue,
                totalFValue,
                AllDeal: OrderByPipeline
            }
            setData(structure);
        } catch (error) {
            message.error(error);
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            getSalesTargetWithGoalsByAccountId(),
            getAllClosedDealByAccountId(),
            leadConversionByAccount(),
            contactByAccountAndId(),
            accountActivityReportByAccountId(),
            resourceUtilizationReportByAccountId(),
            AllEntityScoreForLastSixmonth(),
        ])
        setPageLoading("open")
    };
    // const getColorsForBars = (labels, allDeals, datasetCount, type) => {
    //     return Array.from({ length: datasetCount }, () =>
    //         labels.map((label) => {
    //             const matchedDeal = allDeals.find((deal) => deal.dealName === label);
    //             const pipelineStage = matchedDeal?.pipelineStage;
    //             const baseColor = colorMapping[pipelineStage];
    //             return baseColor ? type !== "BG" ? baseColor : `${baseColor}80` : '#20C99780';
    //         })
    //     );
    // };
    async function GetAll() {
        try {
            const responses = await FetchCurrentYearForcast()
            setCurrentData(responses)
        } catch (error) {
            setCurrentData({})
            message.error(error);
        }
    }
    useEffect(() => {
        if (currency && defaultCurrency) {
            setPageLoading()
            GetAll()
        }
    }, [currency, defaultCurrency])
    useEffect(() => {
        if (currency && isQualified && defaultCurrency) {
            getAllOepenDealByAccountId(isQualified)
        }
    }, [currency, defaultCurrency, isQualified])
    useEffect(() => {
        if (currency && defaultCurrency && currentData) {
            fetchAll();
        }
    }, [currentData, currency, defaultCurrency])
    const closedrawer = () => {
        setPageLoading()
        setCurrency(false)
    }
    const graphSupportMapping = {
        3: ["Pie Chart", "Line Graph", "Donut", "Vertical Bar", "Horizontal Bar"],
        4: ["Pie Chart", "Line Graph", "Donut", "Vertical Bar", "Horizontal Bar"],
        6: ["Stacked Vertical Bar", "Stacked Horizontal Bar"],
    };
    const isGraphSupported = (graphId, graphType) => {
        const supportedGraphs = graphSupportMapping[graphId];
        if (supportedGraphs) {
            return supportedGraphs.includes(graphType);
        }
        return false;
    };
    const changeGraph = (graphId, params) => {
        if (graphId === 3) {
            const data03 = { ...accountReport3, graphType: params, graphDatas: { ...accountReport3.graphDatas, dateFilter: { ...accountReport3.graphDatas.dateFilter } } };
            setGroupData(data03, apiData3)
        }
        if (graphId === 4) {
            const data03 = { ...accountReport4, graphType: params, graphDatas: { ...accountReport4.graphDatas, dateFilter: { ...accountReport4.graphDatas.dateFilter } } };
            setGroupData(data03, apiData4)
        }
        if (graphId === 6) {
            const data03 = { ...accountReport6, graphType: params, graphDatas: { ...accountReport6.graphDatas, dateFilter: { ...accountReport6.graphDatas.dateFilter } } };
            setGroupData(data03, apiData6)
        }
    }
    const Graphs = ({ graphDatas }) => (
        <div style={{ padding: "0px 5px", width: "100%", height: "100%", }}>
            <div role="button" tabIndex={0} onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    changeGraph(graphDatas.graphId, "Pie Chart");
                }
            }} className={`text_icon bulk_action1 ${graphDatas.graphType === "Pie Chart" ? 'graph-active' : ''} ${isGraphSupported(graphDatas.graphId, "Pie Chart") ? "support-graph" : "not-support-graph"}`}
                style={{ pointerEvents: isGraphSupported(graphDatas.graphId, "Pie Chart") ? 'auto' : 'none', }} onClick={graphDatas.graphType === "Pie Chart" ? undefined : () => { changeGraph(graphDatas.graphId, "Pie Chart") }}>
                <PieIcon width={18} height={22} />
            </div>
            <div role="button" tabIndex={0} onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    changeGraph(graphDatas.graphId, "Donut")
                }
            }} className={`text_icon bulk_action1 ${graphDatas.graphType === "Donut" ? 'graph-active' : ''} ${isGraphSupported(graphDatas.graphId, "Donut") ? "support-graph" : "not-support-graph"}`}
                style={{ pointerEvents: isGraphSupported(graphDatas.graphId, "Donut") ? 'auto' : 'none', }} onClick={graphDatas.graphType === "Donut" ? undefined : () => { changeGraph(graphDatas.graphId, "Donut") }}>
                <DonutIcon width={18} height={22} />
            </div>
            <div role="button" tabIndex={0} onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    changeGraph(graphDatas.graphId, "Line Graph")
                }
            }} className={`text_icon bulk_action1 ${graphDatas.graphType === "Line Graph" ? 'graph-active' : ''} ${isGraphSupported(graphDatas.graphId, "Line Graph") ? "support-graph" : "not-support-graph"}`}
                style={{ pointerEvents: isGraphSupported(graphDatas.graphId, "Line Graph") ? 'auto' : 'none', }} onClick={graphDatas.graphType === "Line Graph" ? undefined : () => { changeGraph(graphDatas.graphId, "Line Graph") }}>
                <LineIcon width={18} height={22} />
            </div>
            <div role="button" tabIndex={0} onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    changeGraph(graphDatas.graphId, "Vertical Bar")
                }
            }} className={`text_icon bulk_action1 ${graphDatas.graphType === "Vertical Bar" ? 'graph-active' : ''} ${isGraphSupported(graphDatas.graphId, "Vertical Bar") ? "support-graph" : "not-support-graph"}`}
                style={{ pointerEvents: isGraphSupported(graphDatas.graphId, "Vertical Bar") ? 'auto' : 'none', }} onClick={graphDatas.graphType === "Vertical Bar" ? undefined : () => { changeGraph(graphDatas.graphId, "Vertical Bar") }}>
                <VBIcon width={18} height={22} />
            </div>
            <div role="button" tabIndex={0} onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    changeGraph(graphDatas.graphId, "Horizontal Bar")
                }
            }} className={`text_icon bulk_action1 ${graphDatas.graphType === "Horizontal Bar" ? 'graph-active' : ''} ${isGraphSupported(graphDatas.graphId, "Horizontal Bar") ? "support-graph" : "not-support-graph"}`}
                style={{ pointerEvents: isGraphSupported(graphDatas.graphId, "Horizontal Bar") ? 'auto' : 'none', }} onClick={graphDatas.graphType === "Horizontal Bar" ? undefined : () => { changeGraph(graphDatas.graphId, "Horizontal Bar") }}>
                <HBIcon width={18} height={22} />
            </div>
            <div role="button" tabIndex={0} onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    changeGraph(graphDatas.graphId, "Stacked Vertical Bar")
                }
            }} className={`text_icon bulk_action1 ${graphDatas.graphType === "Stacked Vertical Bar" ? 'graph-active' : ''} ${isGraphSupported(graphDatas.graphId, "Stacked Vertical Bar") ? "support-graph" : "not-support-graph"}`}
                style={{ pointerEvents: isGraphSupported(graphDatas.graphId, "Stacked Vertical Bar") ? 'auto' : 'none', }} onClick={graphDatas.graphType === "Stacked Vertical Bar" ? undefined : () => { changeGraph(graphDatas.graphId, "Stacked Vertical Bar") }}>
                <SVBIcon width={18} height={22} />
            </div>
            <div role="button" tabIndex={0} onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    changeGraph(graphDatas.graphId, "Stacked Horizontal Bar")
                }
            }} className={`text_icon bulk_action1 ${graphDatas.graphType === "Stacked Horizontal Bar" ? 'graph-active' : ''} ${isGraphSupported(graphDatas.graphId, "Stacked Horizontal Bar") ? "support-graph" : "not-support-graph"}`}
                style={{ pointerEvents: isGraphSupported(graphDatas.graphId, "Stacked Horizontal Bar") ? 'auto' : 'none', }} onClick={graphDatas.graphType === "Stacked Horizontal Bar" ? undefined : () => { changeGraph(graphDatas.graphId, "Stacked Horizontal Bar") }}>
                <SHBIcon width={18} height={22} />
            </div>
        </div>
    )
    Graphs.propTypes = {
        graphDatas: PropTypes.object.isRequired,
    };
    const COMPAT = ["T.STK_H", "T.STK_V"]
    const COMPAT4 = ["T.PIE", "T.DONUT", "T.LINE", "T.V_BAR", "T.H_BAR"]
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Account 360"
                open={currency}
                width="80%"
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => { closedrawer(false) }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    closedrawer(false)
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={false}
            >
                {pageLoading ?
                    <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                        <div style={{ margin: 40 }}>
                            <Row gutter={25}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                                    <SalesTargetWrap>
                                        <div id="pdf-content-DBSales-Target">
                                            <Cards bodyStyle={{
                                                height: "325px",
                                                width: "100%",
                                            }}
                                                //  more={<Content ID="Sales-Target" />}
                                                title={
                                                    <div className='Info-withTitle' title="Target vs Achievement (Account level)">
                                                        <span className='Info-withTitle-1'>
                                                            <span className="div-ellipsis Info-withTitle-2">Target vs Achievement (Account level)</span>
                                                        </span>
                                                        <Tooltip
                                                            overlayClassName="ToolTip-Forcast"
                                                            title={
                                                                <div className="report-info">
                                                                    Compares account’s sales targets versus actual achievement, highlighting performance gaps and overall account success
                                                                </div>
                                                            }
                                                        >
                                                            <InfoCircleOutlined className='Info-withTitle-3' />
                                                        </Tooltip>
                                                    </div>
                                                }>
                                                <div className="target-progressbar-wrap">
                                                    {/* <HalfProgressBar percent={chartData && Math.round((chartData.dealValue / chartData.target) * 100)} /> */}
                                                    <Progress
                                                        type="dashboard"
                                                        percent={chartData && Math.round((chartData.dealValue / chartData.target) * 100)}
                                                        format={() => (
                                                            <div style={{ marginTop: -40, fontWeight: 'bold' }}>
                                                                <div style={{ fontSize: 30, color: "#000000" }}>
                                                                    {chartData && chartData.target !== 0
                                                                        ? `${((chartData.dealValue / chartData.target) * 100)?.toFixed(2)}%`
                                                                        : "0%"}
                                                                </div>
                                                                <div style={{ fontSize: 15, color: "#868ebe", marginTop: 10 }}>
                                                                    Progress
                                                                </div>
                                                            </div>
                                                        )}
                                                        gapDegree={180}
                                                        gapPosition="bottom"
                                                        strokeColor={{
                                                            '0%': '#20c997',
                                                            '100%': '#20c997',
                                                        }}
                                                        width={250}
                                                        strokeWidth={8}
                                                    />
                                                </div>
                                                <div className="s-target-list d-flex justify-content-between">
                                                    <div className="s-target-list__item target-revinue">
                                                        <h2>{defaultCurrency?.symbol} {chartData && chartData.dealValue.toLocaleString()}</h2>
                                                        <p>Revenue</p>
                                                    </div>
                                                    <div className="s-target-list__item">
                                                        <h2>{defaultCurrency?.symbol} {chartData && chartData.target.toLocaleString()}</h2>
                                                        <p style={{ textAlign: "right" }}>Target</p>
                                                    </div>
                                                </div>
                                            </Cards>
                                        </div>
                                    </SalesTargetWrap>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                                    <div id="pdf-content-DBOpen-Deals-Count">
                                        <GlobalChart
                                            infoTitle="Tracks account score over the past 6 months to understand engagement, health, and growth potential"
                                            pageSize={pageSize}
                                            data={{
                                                graphId: 7,
                                                graphName: "Account Score Trend",
                                                graphType: "Line Graph",
                                                graphDatas: {
                                                    labels: chartData2.labels,
                                                    datasets: [{
                                                        data: chartData2.dataIn,
                                                        backgroundColor: '#20C997',
                                                        borderWidth: 1,
                                                        fill: false,
                                                    }],
                                                    Sumtotal: total2,
                                                    LegendType: "CurrentScore",
                                                }
                                            }}
                                            graphopenUID={7}
                                            graphDataStandardIndex={7}
                                            pagefrom="Account360"
                                            setPaginationState={setPaginationState}
                                            paginationState={paginationState}
                                            COMPAT={undefined}
                                        // hideLegendLabels
                                        />
                                        {/* <Cards bodyStyle={{
                                            height: "350px",
                                            width: "100%",
                                        }}
                                            title={
                                                <div className='Info-withTitle' title="Account Score Trend">
                                                    <span className='Info-withTitle-1'>
                                                        <span className="div-ellipsis Info-withTitle-2">Account Score Trend</span>
                                                    </span>
                                                    <Tooltip
                                                        overlayClassName="ToolTip-Forcast"
                                                        title={
                                                            <div className="report-info">
                                                                Tracks account score over the past 6 months to understand engagement, health, and growth potential
                                                            </div>
                                                        }
                                                    >
                                                        <InfoCircleOutlined className='Info-withTitle-3' />
                                                    </Tooltip>
                                                </div>
                                            }
                                            size="large">
                                            <Row gutter={30}>
                                                <Col
                                                    xs={7} sm={7} md={7} lg={7} xl={7} xxl={7}
                                                    style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}
                                                >
                                                    <CardBarChart2>
                                                        <div style={{
                                                            fontSize: 20,
                                                            fontWeight: 600
                                                        }}>{total2}</div>
                                                        <span>Current Score</span>
                                                    </CardBarChart2>
                                                </Col>
                                                <Col xs={17} sm={17} md={17} lg={17} xl={17} xxl={17}>
                                                    <Line Lables={chartData2.labels} Dataset={[
                                                        {
                                                            data: chartData2.dataIn,
                                                            backgroundColor: '#20C997',
                                                        },
                                                    ]} datasetKeyProvider={datasetKeyProvider} height={290} />
                                                </Col>
                                            </Row>
                                        </Cards> */}
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                    {(() => {
                                        const totalLabels = data?.labels || [];
                                        const dValue = data?.dealValue || [];
                                        const fValue = data?.dealForecast || [];
                                        const pValue = data?.dealProfit || [];
                                        const pagedLabels = totalLabels
                                        const pagedDValue = dValue
                                        const pagedFValue = fValue
                                        const pagedPValue = pValue
                                        const pagedGraphData =
                                        {
                                            ...data,
                                            labels: pagedLabels,
                                            dealValue: pagedDValue,
                                            forcastValue: pagedFValue,
                                            profitValue: pagedPValue
                                        }
                                        const formattedGraphData = data ? {
                                            graphId: data?.graphId,
                                            graphType: "Vertical Bar",
                                            graphName: "Open Deals vs Deal Profit vs Forecast (by Deal)",
                                            graphColumnIsCurrency: "YES",
                                            graphRowIsCurrecny: "NO",
                                            checkbox: "YES",
                                            checkboxLable: "Qualified only",
                                            graphType1: "Bar+Line2",
                                            groupLable: [
                                                {
                                                    lable: "Deal Value",
                                                    value: pagedGraphData?.totalDValue
                                                },
                                                {
                                                    lable: "Deal Profit",
                                                    value: pagedGraphData?.totalPValue
                                                },
                                                {
                                                    lable: "Forecast",
                                                    value: pagedGraphData?.totalFValue
                                                }
                                            ],
                                            colorByAccount1: true,
                                            AllDeal: data?.AllDeal,
                                            graphDatas: {
                                                dateFilter: {
                                                    isFilter: data?.graphDatas?.dateFilter?.isFilter,
                                                    filterType: data?.graphDatas?.dateFilter?.filterType
                                                },
                                                labels: pagedGraphData.labels,
                                                datasets: [
                                                    {
                                                        label: "Open Deal Value",
                                                        data: pagedGraphData.dealValue,
                                                    },
                                                    {
                                                        label: "Deal Profit",
                                                        data: pagedGraphData.profitValue,
                                                    },
                                                    {
                                                        label: "Forecast",
                                                        data: pagedGraphData.forcastValue,
                                                    },
                                                ],
                                            }
                                        } : null;

                                        return (
                                            <GlobalChart
                                                infoTitle="Displays open deal values, forecast, and potential profit, categorized by pipeline phase for detailed deal insights"
                                                isQualified={isQualified}
                                                pageSize={pageSize}
                                                data={formattedGraphData}
                                                handleActiveChange={setIsQualified}
                                                Content={undefined}
                                                graphopenUID={data?.graphId}
                                                graphDataStandardIndex={24}
                                                pagefrom={undefined}
                                                actions={undefined}
                                                openPage={undefined}
                                                setPaginationState={setPaginationState}
                                                handleQualifiedChange2={setIsQualified}
                                                showonlyLegend
                                                paginationState={paginationState}
                                                COMPAT={undefined}
                                            />)
                                    })()}
                                  
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                    {(() => {
                                        const totalLabels = data1?.labels || [];
                                        const dValue = data1?.dealValue || [];
                                        const fValue = data1?.dealForecast || [];
                                        const pValue = data1?.dealRevenue || [];
                                        const pagedLabels = totalLabels
                                        const pagedDValue = dValue
                                        const pagedFValue = fValue
                                        const pagedPValue = pValue
                                        const pagedGraphData =
                                        {
                                            ...data1,
                                            labels: pagedLabels,
                                            dealValue: pagedDValue,
                                            forcastValue: pagedFValue,
                                            dealRevenue: pagedPValue
                                        }
                                        const formattedGraphData = data1 ? {
                                            graphId: data1?.graphId,
                                            graphType: "Vertical Bar",
                                            graphName: "Won Deals vs Revenue vs Deal Profit (by Deal)",
                                            graphColumnIsCurrency: "YES",
                                            graphRowIsCurrecny: "NO",
                                            graphType1: "Bar+Line",
                                            groupLable: [{
                                                lable: "Won Deal Value (FY)",
                                                value: pagedGraphData?.totalDValue
                                            },
                                            {
                                                lable: "FY Revenue",
                                                value: pagedGraphData?.totalPValue
                                            }, {
                                                lable: "Deal Profit (FY)",
                                                value: pagedGraphData?.totalFValue
                                            }],
                                            graphDatas: {
                                                dateFilter: {
                                                    isFilter: data?.graphDatas?.dateFilter?.isFilter,
                                                    filterType: data?.graphDatas?.dateFilter?.filterType
                                                },
                                                labels: pagedGraphData.labels,
                                                datasets: [
                                                    {
                                                        label: "Won Deal Value (FY)",
                                                        data: pagedGraphData.dealValue,
                                                    },
                                                    {
                                                        label: "FY Revenue",
                                                        data: pagedGraphData.dealRevenue,
                                                    },
                                                    {
                                                        label: "Deal Profit (FY)",
                                                        data: pagedGraphData.forcastValue,
                                                    },
                                                ],
                                            }
                                        } : null;
                                        return (
                                            <GlobalChart infoTitle="Shows closed-won deal values, revenue, and profit for each deal, helping assess profitability and performance"
                                                pageSize={pageSize} data={formattedGraphData} handleActiveChange={undefined} Content={undefined} graphopenUID={data1?.graphId} graphDataStandardIndex={24}
                                                pagefrom={undefined} actions={undefined} openPage={undefined} setPaginationState={setPaginationState} showonlyLegend
                                                paginationState={paginationState} COMPAT={undefined} />)
                                    })()}
                                   
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                    {accountReport6 ?
                                        <div id={`pdf-content-G${accountReport6.graphId}`} className='Report-DateFilter'>
                                            <GlobalChart
                                                infoTitle="Breaks down contacts by source and conversion status, highlighting which sources generate the most successful leads"
                                                pageSize={OwnpageSize}
                                                data={accountReport6}
                                                graphopenUID={6}
                                                graphDataStandardIndex={6}
                                                pagefrom="Account360"
                                                setPaginationState={setPaginationState}
                                                paginationState={paginationState}
                                                COMPAT={COMPAT}
                                            />
                                         
                                        </div> :
                                        <div className="spin">
                                            <Spin />
                                        </div>}
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                    {accountReport5 ?
                                        <div id={`pdf-content-G${accountReport5.graphId}`} className='Report-DateFilter'>
                                            <GlobalChart
                                                infoTitle="Tracks number of leads added versus those converted into contacts across lead source to monitor pipeline effectiveness"
                                                pageSize={OwnpageSize}
                                                data={{
                                                    graphId: 5,
                                                    graphType: "Bar+Line",
                                                    graphName: accountReport5.graphName,
                                                    graphColumnIsCurrency: "NO",
                                                    graphRowIsCurrecny: "NO",
                                                    groupLable: [
                                                        {
                                                            lable: "Total Added",
                                                            value: accountReport5.graphDatas.totalAdd
                                                        },
                                                        {
                                                            lable: "Total Converted",
                                                            value: accountReport5.graphDatas.totalConvert
                                                        }
                                                    ],
                                                    graphDatas: {
                                                        labels: accountReport5.graphDatas.labels,
                                                        datasets: [
                                                            {
                                                                data: accountReport5.graphDatas.Add,
                                                                backgroundColor: '#20C99780',
                                                                hoverBackgroundColor: '#20C997',
                                                                label: 'Added',
                                                                average: accountReport5.graphDatas.totalAdd,
                                                                maxBarThickness: 10,
                                                                barThickness: 12,
                                                            },
                                                            {
                                                                data: accountReport5.graphDatas.Convert,
                                                                backgroundColor: '#407fe980',
                                                                hoverBackgroundColor: '#407fe9',
                                                                label: 'Converted',
                                                                average: accountReport5.graphDatas.totalConvert,
                                                                maxBarThickness: 10,
                                                                barThickness: 12,
                                                            },
                                                        ],
                                                    }
                                                }}
                                                graphopenUID={5}
                                                graphDataStandardIndex={5}
                                                pagefrom="Account360"
                                                setPaginationState={setPaginationState}
                                                paginationState={paginationState}
                                                COMPAT={undefined}
                                                graphRowIsCurrecny="NO"
                                                graphColumnIsCurrency="NO"
                                                // LegendType={false}
                                                showonlyLegend
                                            />
                                           
                                        </div> :
                                        <div className="spin">
                                            <Spin />
                                        </div>}
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                                    {accountReport3 ?
                                        <div id={`pdf-content-G${accountReport3.graphId}`} className='Report-DateFilter'>
                                            <GlobalChart
                                                infoTitle="Monitors account activities like emails, meetings, and tasks to measure engagement and follow-up effectiveness"
                                                pageSize={pageSize}
                                                data={accountReport3}
                                                graphopenUID={3}
                                                graphDataStandardIndex={3}
                                                pagefrom="Account360"
                                                setPaginationState={setPaginationState}
                                                paginationState={paginationState}
                                                COMPAT={COMPAT4}
                                                showLegendValues={false}
                                            />
                                          
                                        </div> :
                                        <div className="spin">
                                            <Spin />
                                        </div>}
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                                    {accountReport4 ?
                                        <div id={`pdf-content-G${accountReport4.graphId}`} className='Report-DateFilter'>
                                            <GlobalChart
                                                infoTitle="Shows usage of resources (staff, products, services) associated with the account for efficient allocation"
                                                pageSize={pageSize}
                                                data={accountReport4}
                                                graphopenUID={4}
                                                graphDataStandardIndex={4}
                                                pagefrom="Account360"
                                                setPaginationState={setPaginationState}
                                                paginationState={paginationState}
                                                COMPAT={COMPAT4}
                                                showLegendValues={false}
                                            />
                                           
                                        </div> :
                                        <div className="spin">
                                            <Spin />
                                        </div>}
                                </Col>
                            </Row>
                        </div >
                    </Scrollbars > :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
        </>
    );
};

Popup.propTypes = {
    currency: PropTypes.bool.isRequired,
    setCurrency: PropTypes.func.isRequired,
    DataId: PropTypes.number.isRequired,
    UserId: PropTypes.number.isRequired,
};

export default Popup;
